import { Outlet } from "react-router-dom";
import QuestionPaperTopBar from "./topBar";

function QuestionPaperLayout() {
  return (
    <div className="container-fluid vh-100 d-flex flex-column p-0 position-relative">
      <div className="w-100">
        <QuestionPaperTopBar />
      </div>

      <div
        className="flex-grow-1 overflow-auto py-3 px-5"
        style={{ backgroundColor: "rgb(240 242 247 / 54%)" }}
      >
        <Outlet />
      </div>
    </div>
  );
}

export default QuestionPaperLayout;

// old code for backup sidebar
// <div className="container-fluid vh-100 d-flex p-0 position-relative">
//   <div
//     className={`sidebar-wrapper-qstn ${isSidebarOpen ? "open" : "closed"}`}
//   >
//     <div className="sidebar-qstn-inner">
//       <div className="p-3">
//         <IconButton
//           sx={{ position: "absolute", top: 8, right: 8 }}
//           onClick={() => setIsSidebarOpen(false)}
//         >
//           ✕
//         </IconButton>
//         <Sidebar />
//       </div>
//     </div>
//   </div>

//   <div
//     className="flex-grow-1 overflow-auto p-3"
//     style={{ backgroundColor: "rgb(240 242 247 / 54%)" }}
//   >
//     {!isSidebarOpen && (
//       <IconButton
//         onClick={() => setIsSidebarOpen(true)}
//         sx={{ position: "absolute", top: 8, left: 8, zIndex: 1000 }}
//       >
//         <MenuIcon />
//       </IconButton>
//     )}
//     <br />
//     <Outlet />
//   </div>
// </div>
